const StampCard = {
  path: "",
  name: "",
  redirect: "/stampcard",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/stampcard",
      redirect: "/stampcard",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Beauty Passport",
      meta: {
        requiresAuth: true,
        activeUrl: "/stampcard",
        parent: "stampcard",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/stampcard/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/stampcard",
            parent: "stampcard",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Beauty Passport Detail",
          component: () => import("@/views/pages/stampcard/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/stampcard",
            parent: "stampcard",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default StampCard;
